import { Input, InputWrapperProps } from '@mantine/core';
import { ForwardedRef, forwardRef } from 'react';

import classNames from './InputWrapper.module.scss';

export type IInputWrapperProps = InputWrapperProps & {
  hasError?: boolean;
  marginLeft?: string;
};

export const ZorroInputWrapper = forwardRef(
  (
    {
      size = 'sm',
      hasError,
      marginLeft = '-0.25rem',
      ...props
    }: IInputWrapperProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Input.Wrapper
        ref={ref}
        size={size}
        classNames={classNames}
        styles={(theme) => ({
          root: { borderRadius: 50 },
          label: { fontWeight: 400 },
          required: {
            color: hasError
              ? 'var(--color-text-error-primary)'
              : theme.colors.zorroCoal[9],
            marginLeft,
          },
        })}
        {...props}
      />
    );
  }
);

ZorroInputWrapper.displayName = 'ZorroInputWrapper';
